<template>
  <!--公司资质-->
  <section id="qualification">
    <div class="caption">
      <h2>公司资质</h2>
      <span>QUALIFICATION</span>
    </div>

    <div class="qualification">
      <img src="@/assets/images/aboutus/qualification.jpg" alt="">
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss"  scoped>
@import "@/assets/styles/common.scss";

.caption {
  // width: 40%;
  padding-bottom: 30px;
  text-align: center;

  > h1 {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 22px;
    text-align: center;
    color: #333333;
  }
}

section {
  /* 资质 */
  &#qualification {
    width: $SIZE_PAGE_WIDTH;
    margin-bottom: 30px;
    text-align: center;

    > .qualification {
      width: 100%;
      margin-bottom: 20px;

      > img {
        width: 100%;
      }
    }
  }
}
</style>